'use client'

import Image from 'next/image'

interface PhotoCarouselProps {
  photos: string[]
  altPrefix: string
}

export function PhotoCarousel({ photos, altPrefix }: PhotoCarouselProps) {
  return (
    <>
      {/* Mobile: vertical stack */}
      <div className="flex flex-col gap-4 px-4 sm:hidden">
        {photos.map((src, i) => (
          <div
            key={i}
            className="w-full aspect-video relative rounded-2xl overflow-hidden border border-white/10"
          >
            <Image
              src={src}
              alt={`${altPrefix} ${i + 1}`}
              fill
              className="object-cover"
              sizes="100vw"
              priority={i === 0}
              quality={90}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none" />
          </div>
        ))}
      </div>

      {/* Desktop: horizontal scroll carousel */}
      <div
        className="hidden sm:flex gap-6 overflow-x-auto scroll-smooth"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        <div className="flex-shrink-0 sm:w-8 lg:w-16" aria-hidden />

        {photos.map((src, i) => (
          <div
            key={i}
            className="flex-shrink-0 sm:w-[65vw] lg:w-[720px] aspect-video relative rounded-3xl overflow-hidden border border-white/10 hover:border-strandforge-purple/40 transition-all duration-300"
          >
            <Image
              src={src}
              alt={`${altPrefix} ${i + 1}`}
              fill
              className="object-cover"
              sizes="(max-width: 1024px) 65vw, 720px"
              priority={i === 0}
              quality={90}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none" />
          </div>
        ))}

        <div className="flex-shrink-0 sm:w-[calc(35vw-32px)] lg:w-[calc(100vw-784px)]" aria-hidden />
      </div>
    </>
  )
}
